import { combineReducers } from 'redux'
import * as types from 'models/actionTypes'

const initialState = {
    hasAddedToBag: false,
}

const hasAddedToBag = (state = initialState.hasAddedToBag, action) => {
    switch (action.type) {
        case types.ADD_TO_BAG:
        case types.ADD_ROOM_TO_BAG:
            return true
        default:
            return state
    }
}

export default combineReducers({ hasAddedToBag })
